"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var babelPluginFlowReactPropTypes_proptype_CommonType = {
  style: require("prop-types").shape({}),
  className: require("prop-types").string
};
if (typeof exports !== "undefined") Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_CommonType", {
  value: babelPluginFlowReactPropTypes_proptype_CommonType,
  configurable: true
});
exports.default = {};